import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, MenuItem, TextField } from "@mui/material";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { generateChartData, findKeyByValue } from "../../services/helper";
// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const LineChart = () => {
  const [time, setTime] = useState(30);
  const [user, setUser] = useState("All");
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [metrics, setMetrics] = useState([]);
  const days = [30, 60, 90];
  const backendData = [
    { updatedAt: "2024-12-01", status: "Queried", owner: "Leonard Beadle" },
    { updatedAt: "2024-12-02", status: "Rejected", owner: "Leonard Beadle" },
    { updatedAt: "2024-12-02", status: "Queried", owner: "Leonard Beadle" },
    { updatedAt: "2024-12-03", status: "Pending", owner: "Tony Jenkins" },
    { updatedAt: "2024-12-04", status: "Approved", owner: "Tony Jenkins" },
    { updatedAt: "2024-12-02", status: "Approved", owner: "Tony Jenkins" },
    { updatedAt: "2024-12-02", status: "Approved", owner: "Tony Jenkins" },
    { updatedAt: "2024-10-02", status: "Approved", owner: "Tony Jenkins" },
  ];
  useEffect(() => {
    const dummyChartData = generateChartData(backendData, time, user);
    const statusCounts = calculateStatusCounts(dummyChartData);
    const metric = [
      { label: "Pending", value: statusCounts.Pending },
      { label: "Queried", value: statusCounts.Queried },
      { label: "Escalated", value: statusCounts.Approved },
      { label: "No action taken", value: statusCounts.Rejected },
    ];
    setChartData(dummyChartData);
    setMetrics(metric);
  }, [time, user]);

  const calculateStatusCounts = (dummyData) => {
    const statusCounts = {
      Pending: 0,
      Rejected: 0,
      Queried: 0,
      Approved: 0,
    };
    dummyData.datasets.forEach((dataset) => {
      const label = dataset.label;
      if (statusCounts[findKeyByValue(label)] !== undefined) {
        const total = dataset.data.reduce((sum, value) => sum + value, 0);
        statusCounts[findKeyByValue(label)] += total;
      }
    });

    return statusCounts;
  };

  const handleFilterChange = (filterType, value) => {
    switch (filterType) {
      case "time":
        setTime(value);
        break;
      case "user":
        setUser(value);
        break;
      default:
        break;
    }

    console.log("Filters:", { time, user });
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1, // Ensure the y-axis increments by 1
          callback: function (value) {
            return Number(value).toFixed(0); // Ensure whole numbers
          },
        },
      },
      x: {
        ticks: {
          maxRotation: 45, // Optional: Rotate x-axis labels for better visibility
          minRotation: 45,
        },
      },
    },
  };

  return (
    <Grid container mb={4} p={2}>
      {/* Filter Section */}
      <Grid container spacing={2} mb={4} xs={6}>
        {/* Time Filter */}
        <Grid item xs={4}>
          <TextField
            fullWidth
            select
            margin="normal"
            name="time"
            label="Time"
            value={time || ""}
            onChange={(e) => handleFilterChange("time", e.target.value)}
            required
          >
            {days.map((day) => (
              <MenuItem value={day} key={day}>
                Last {day} Days
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* User Filter */}
        <Grid item xs={4}>
          <TextField
            fullWidth
            select
            margin="normal"
            name="user"
            label="User"
            value={user}
            onChange={(e) => handleFilterChange("user", e.target.value)}
            required
          >
            {["All", "Tony Jenkins", "Leonard Beadle"].map((option) => (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      {/* Metrics Section */}
      <Grid container spacing={2}>
        {metrics.map((metric, index) => (
          <Grid item xs={3} key={index}>
            <Box textAlign="center">
              <Typography variant="h6">{metric.label}</Typography>
              <Typography variant="h4">{metric.value}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Chart Section */}
      <Grid container>
        <div style={{ width: "100%", height: "45vh" }}>
          <Line options={options} data={chartData} />
        </div>
      </Grid>
    </Grid>
  );
};

export default LineChart;
